import React from 'react'
import styled from 'styled-components'
import media from '../../../styles/media'

const ButtonWrapper = styled.button`
  &.btn {
    padding: 15px 30px;
    border-radius: 0;
    line-height: normal;
    background-color: transparent;
    border-color: white;
  }
  display: block;
  text-decoration: none;
  cursor: pointer;
  background-color: #ffffff;
  &:hover {
    background-color: #40b4e4;
  }
`
const TextButton = styled.span`
  font-size: 0.9rem;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 3px;
  text-align: center;
  color: white;
  @media (max-width: 768px) {
    font-size: 10px;
  }
`

function Button({ onClick, title }) {
  return (
    <div>
      <ButtonWrapper className="btn" onClick={onClick}>
        <TextButton>{title.toUpperCase()}</TextButton>
      </ButtonWrapper>
    </div>
  )
}

export default Button



// WEBPACK FOOTER //
// ./src/components/step/button/button.js